import { stats } from '@/mocks/home';

export default function StatsBand() {
  return (
    <section className="border-b border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">速度与稳定，看得见</h2>
          <p className="text-sm text-foreground-600">数据来自线路实时监测（演示数据）</p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 lg:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.id} className="bg-background-50 px-4 py-6 text-center md:px-6 md:py-8">
              <p className="font-heading text-3xl text-primary-600 md:text-4xl">{stat.value}</p>
              <p className="mt-2 text-xs text-foreground-600 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}